import { render, staticRenderFns } from "./Winelands.vue?vue&type=template&id=a9b0a0ee&"
import script from "./Winelands.vue?vue&type=script&lang=js&"
export * from "./Winelands.vue?vue&type=script&lang=js&"
import style0 from "./Winelands.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports